<template>
  <div class="Result">
    <div class="Head">
      <div class="Total">検索結果 {{ singleProductSearchTotal }}件</div>
      <button class="Clear" @click="clear">絞り込みクリア</button>
    </div>
    <div class="Body" v-if="singleProductSearchTotal">
      <div class="SummaryWrapper" v-for="product in singleProductSearchResults" :key="product.inventory_product_id" >
        <Summary class="Summary" :data="product" :disable-view-transition />
      </div>
    </div>

    <div class="Empty" v-else>
      <div class="EmptyHead">条件に一致する商品は見つかりませんでした。</div>
      <div class="EmptyBody">
        <div class="EmptyHintHead">検索のヒント</div>
        <ul class="EmptyHints">
          <li>検索キーワードを変更する</li>
          <li>絞り込み条件を解除する</li>
          <li>絞り込み範囲を広く設定する</li>
        </ul>
      </div>
    </div>
    <Pagination
      v-if="singleProductSearchTotalPages >= 2"
      :total-pages="singleProductSearchTotalPages"
      :model-value="pokemonStore.currentSingleProductSearchPage"
      @update:model-value="paginate"
      />
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent, useNuxtApp, useRouter } from '#app'
import { DITokens } from '@/di'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { Pagination } from '@ka-nabellinc/ka-nabell-ui'
import Summary from '@/components/Pokemon/Single/Summary'

export default defineNuxtComponent({
  components: {
    Summary,
    Pagination
  },
  setup() {
    const { $container } = useNuxtApp()
    const cartStore = $container.resolve(DITokens.CartStore);
    const cartState = storeToRefs(cartStore);
    const disableViewTransition = computed(() => cartState.showCart.value) // カート表示中はview transitionをoff
    const router = useRouter()
    const pokemonStore = $container.resolve(DITokens.PokemonStore)
    const {
      showSingleProductSearchDetailMenu,
      singleProductSearchResults,
      singleProductSearchTotal,
      singleProductSearchTotalPages,
    } = storeToRefs(pokemonStore)

    const clear = () => {
      pokemonStore.clearPokemonSingleSearch()
    }
    const paginate = async (page: number) => {
      await pokemonStore.searchSingleProduct(page)
      if (showSingleProductSearchDetailMenu.value) {
        showSingleProductSearchDetailMenu.value = false
      }
      router.replace({ query: { ...router.currentRoute.value.query, page } })
      if (!process.client) return
      // ページトップにスクロール
      window.scrollTo({
        behavior: 'smooth',
        top:0
      })
    }

    return {
      pokemonStore,
      singleProductSearchTotal,
      singleProductSearchResults,
      singleProductSearchTotalPages,
      clear,
      paginate,
      disableViewTransition
    }
  }
})
</script>

<style scoped>
.Result {
  width: 100%;
}

.Head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.Total {
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

.Clear {
  font-size: 13px;
  line-height: 150%;
  letter-spacing: 0.13px;
  text-decoration: underline;
  cursor: pointer;
  color: var(--semantic-colors-text-black);
}

.Body {
  width: 100%;
  display: flex;
  column-gap: 16px;
  row-gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.SummaryWrapper {
  width: calc((100% - (16px * 2)) / 3);
}

.Empty {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.EmptyHead {
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

.EmptyBody {
  width: 100%;
  background: #F9F9F9;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 20px 16px;
}

.EmptyHintHead {
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.3px;
}

.EmptyHints {
  margin: 0;
  padding-left: 0;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.12px;
}
</style>
